import React from 'react';
import { MessageSquare } from 'lucide-react';
import { Button } from '../ui/button';

/**
 * SMS click-to-text button.
 * Opens the user's default messaging app with a pre-filled body — usually
 * converts much better than a contact form on mobile.
 *
 * Props:
 *   phone: E.164 format (e.g. "+14102157474")
 *   message: text to pre-fill in the message body
 *   label: visible button label
 *   testId: data-testid override (optional)
 *   variant: 'primary' (gold, filled) | 'ghost' (outlined) — defaults to 'primary'
 */
const PRIMARY_STYLE = {
  background: 'linear-gradient(90deg, #25D366 0%, #128C7E 100%)',
  color: '#fff',
  fontWeight: 800,
  border: 'none',
  padding: '0.55rem 1.1rem',
  fontSize: '0.92rem',
  boxShadow: '0 6px 18px rgba(37, 211, 102, 0.35)',
};

const GHOST_STYLE = {
  background: 'transparent',
  color: '#25D366',
  fontWeight: 700,
  border: '1px solid rgba(37, 211, 102, 0.55)',
  padding: '0.5rem 1rem',
  fontSize: '0.88rem',
};

const SmsCoachButton = ({
  phone,
  message,
  label = 'Text a Coach',
  testId = 'sms-coach-btn',
  variant = 'primary',
}) => {
  const href = `sms:${phone}${message ? `?body=${encodeURIComponent(message)}` : ''}`;
  return (
    <a href={href} data-testid={testId} style={{ textDecoration: 'none' }}>
      <Button style={variant === 'ghost' ? GHOST_STYLE : PRIMARY_STYLE}>
        <MessageSquare size={16} />
        &nbsp;{label}
      </Button>
    </a>
  );
};

export default SmsCoachButton;
